import React from 'react';
import styled from 'styled-components';
import { Flex } from '../../lib/components/LessonPath/static/style';

export const LessonsBackGround = (props) => {
    return (
        <Background>
            <TopLeft />
            <TopRight />
            <BottomLeft />
            <BottomRight />
            <BottomCenter />
            {props.children}
        </Background>
    );
}

export const LessonNodeBackGround = (props) => {
    return (
        <Background type='simple'>
            {props.children}
        </Background>
    );
}

const Background = styled(Flex)`
    width: 100%;
    height: 100%;
    background: url(${props => (props && props.type && props.type === 'simple') ? require('./img/bg-simple.png') : require('./img/bg.png')}) no-repeat center;
    background-size: cover;
    justify-content: center;
    align-items: center;
`;

const FixedGrass = styled.div`
    position: fixed;
`;

const TopLeft = styled(FixedGrass)`
    top: 0;
    left: 0;
    width: 3.98rem;
    height: 4.38rem;
    background: url(${require('./img/top-left.png')}) no-repeat left;
    background-size: contain;
`;

const TopRight = styled(FixedGrass)`
    top: 0;
    right: 0;
    width: 7.52rem;
    height: 5.2rem;
    background: url(${require('./img/top-right.png')}) no-repeat right;
    background-size: contain;
`;

const BottomLeft = styled(FixedGrass)`
    bottom: 0;
    left: 0;
    width: 5.78rem;
    height: 3.74rem;
    background: url(${require('./img/bottom-left.png')}) no-repeat left bottom;
    background-size: contain;
`;

const BottomRight = styled(FixedGrass)`
    bottom: 0;
    right: 0;
    width: 4.11rem;
    height: 2.95rem;
    background: url(${require('./img/bottom-right.png')}) no-repeat left bottom;
    background-size: contain;
`;

const BottomCenter = styled(FixedGrass)`
    bottom: 0;
    right: 17.9%;
    width: 2.59rem;
    height: 1.09rem;
    background: url(${require('./img/bottom-center.png')}) no-repeat left bottom;
    background-size: contain;
`;



// WEBPACK FOOTER //
// ./src/components/lesson-path/path-background.js